import axios from 'axios';

const getEntitiesWithTaxForms = params =>
  axios.post('/review_and_export/get_entities_with_tax_forms', params);

export default {
  getEntitiesWithTaxForms,
};
